import { FC } from 'react'
import { SocialMediaProps } from './interfaces'

const Twitter: FC<SocialMediaProps> = ({
  width = 19,
  height = 19,
  color = 'white',
}) => {
  const fillColor = {
    white: '#FFFFFF',
    'grey-500': '#75787B',
    black: '#212721',
  }
  const DEFAULT_COLOR = fillColor.white

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2904 1.69397C18.7625 2.42072 18.1248 3.04059 17.3736 3.55181C17.3831 3.65691 17.3869 3.81187 17.3869 4.02028C17.3869 4.98572 17.2374 5.94759 16.9384 6.90947C16.6376 7.86956 16.1835 8.79225 15.5704 9.67575C14.9611 10.5592 14.2326 11.3394 13.3906 12.0181C12.5467 12.6985 11.5306 13.24 10.3385 13.6444C9.14829 14.0487 7.87484 14.25 6.51814 14.25C4.38185 14.25 2.42722 13.7138 0.652344 12.6362C0.928604 12.6665 1.23703 12.6807 1.57573 12.6807C3.34872 12.6807 4.9287 12.1695 6.31757 11.1453C5.48879 11.1292 4.74894 10.8906 4.09424 10.4274C3.43954 9.96253 2.99109 9.37116 2.747 8.65153C3.00623 8.68894 3.24843 8.70675 3.46793 8.70675C3.80663 8.70675 4.14155 8.66578 4.47268 8.58384C3.58903 8.41284 2.85864 7.99959 2.27963 7.34231C1.69873 6.68681 1.40922 5.92444 1.40922 5.05519V5.01066C1.9466 5.29209 2.52183 5.44528 3.13679 5.46666C2.61644 5.14069 2.20205 4.71319 1.89551 4.18594C1.58709 3.66047 1.43382 3.08869 1.43382 2.47237C1.43382 1.81866 1.60601 1.21481 1.95417 0.657281C2.90784 1.76344 4.06775 2.64872 5.4377 3.31312C6.80386 3.97753 8.26842 4.34625 9.82948 4.42106C9.76703 4.13962 9.73487 3.86353 9.73487 3.59634C9.73487 2.60241 10.1095 1.75453 10.8532 1.05272C11.5987 0.352687 12.4975 0 13.5552 0C14.6602 0 15.5893 0.379406 16.3462 1.13644C17.2071 0.981469 18.0132 0.691125 18.772 0.268969C18.4787 1.12219 17.9186 1.78125 17.0917 2.24972C17.8259 2.17491 18.5563 1.98966 19.2904 1.69397Z"
        fill={fillColor[color] || DEFAULT_COLOR}
      />
    </svg>
  )
}

export default Twitter
